import { render, staticRenderFns } from "./kalender.html?vue&type=template&id=320565fb&"
import script from "./kalender.js?vue&type=script&lang=js&"
export * from "./kalender.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports